import React from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron';
 
const Error = () => {
    return (
       <Jumbotron>
          <p>Error: Page does not exist!</p>
       </Jumbotron>
    );
}
 
export default Error;